import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, Icon, } from '@chakra-ui/react';
import { BxsChevronDown } from './BxsChevronDown';
/**
 * ToggleChevron that gives a visual cue of the open/close state of the item.
 * It rotates `180deg` based on the open/close state.
 */
export const ToggleChevron = forwardRef(({ isOpen, reduceMotion, styles, ...props }, ref) => {
    const iconStyles = {
        transform: isOpen ? 'rotate(-180deg)' : undefined,
        transition: reduceMotion ? undefined : 'transform 0.2s',
        transformOrigin: 'center',
        ...styles,
    };
    return (_jsx(Icon, { ref: ref, viewBox: "0 0 24 24", __css: iconStyles, as: BxsChevronDown, ...props }));
});
